
function V4Container() {
    /// <summary>
    /// This object provides js functions for different V4-visuals which cannot be used vcForms as sub widget. 
    //  So, we have this as a type of convertor from v4 visuals to v2 visuals<br />
    /// <br/>
    /// Author: AFU<br />
    /// Date: 16.4.2025<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 16.4.2025                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

}

V4Container.prototype = new vcTemplate();

V4Container.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        //we split the parameters - visual name | loggerid
        var param = me.param.split("|");
        //in signal parameters we only get the id of the parent widget
        var id = parseInt(me.signalParam);
        switch (param[0]) {

            case "DeviceAttributes":
                me.visual.DeviceAttributes({ invokeType: "addVisualBase", blid: parseInt(param[1]), parameter: { "dmdid": id } }); break;

            default:
        }
      

    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



V4Container.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
           me.visual.hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


